import { memo, useCallback, ReactElement } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { Build } from '@mui/icons-material';
import { store } from '@src/store';
import { CommandButtonColumnProps } from './types';
import useAlias from '@alias';

const CommandButtonColumn: React.FC<CommandButtonColumnProps> = ({
  deviceId,
  openCmdModal,
  disabled,
}): ReactElement => {
  const alias = useAlias();
  const { controlsLockConfig } = store.getState().config.siteMeta.ui;
  const tooltipTitle = alias(
    `Controls disabled. ${controlsLockConfig?.pointName} is above the threshold of ${controlsLockConfig?.thresholdMax}.`,
  );

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      openCmdModal(deviceId);
    },
    [deviceId, openCmdModal],
  );

  return (
    <Tooltip
      title={disabled ? tooltipTitle : ''}
      placement='top'
      disableHoverListener={!disabled}
    >
      <Box p={0}>
        <IconButton onClick={handleClick} disabled={disabled}>
          <Build />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

CommandButtonColumn.displayName = 'CommandButtonColumn';

export default memo(CommandButtonColumn);
